export const DYNAMIC_CALL_TRANSFER_ENTRY_LIMIT = 1000;
